// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"5cdaa116","229":"07836622","605":"50548675","769":"8920f584","787":"a772ca47","981":"db0b70f6"}[chunkId] + ".chunk.js";
};